import type { PortfolioAccount, PortfolioBalance } from "@/types/portfolio"
import client from "./client"

export async function getPortfolioAccounts(): Promise<PortfolioAccount[]> {
  const { data } = await client.get<PortfolioAccount[]>("/api/portfolio/accounts")
  return data
}

export async function getPortfolioBalance(accountNumber: string): Promise<PortfolioBalance> {
  const { data } = await client.get<PortfolioBalance>("/api/portfolio/balance", {
    params: { accountNumber },
  })
  return data
}
